import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  selector: 'aux-processing-loader',
  styles: [],
  template: `
    <div class="flex items-center border border-aux-warn bg-white p-4">
      <aux-icon
        name="Loader"
        class="animate-spin text-aux-gray-darkest"
        style="animation: spin 5s linear infinite"
      />
      <span class="ml-6 text-lg">{{ message }}</span>
    </div>
  `,
})
export class ProcessingLoaderComponent {
  @Input() message!: string;
}
